import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { unpackToDateTime } from '@campfire/hot-date';
import { MessageBubble } from './MessageBubble';

export interface SmsThreadMessage {
  id: string;
  body: string;
  inbound: boolean;
  at: string;
  author: string;
}

/**
 * The single SMS conversation view used by every communications surface: the profile's
 * CommunicationDetailDialog, the Inbox thread panel and the Sent message panel. Messages show in the
 * order given, with a heading at each change of day.
 */
export const SmsThread = ({ messages }: { messages: SmsThreadMessage[] }) => (
  <Box>
    {messages.map((message, index) => {
      const at = unpackToDateTime(message.at);
      const previous = index > 0 ? unpackToDateTime(messages[index - 1].at) : undefined;
      const showDay = !previous || !previous.hasSame(at, 'day');

      return (
        <Box key={message.id} marginBottom='10px'>
          {showDay && (
            <Box textAlign='center' marginBottom='14px' marginTop={index > 0 ? '8px' : 0}>
              <Typography style={{ fontSize: 12, color: '#646464' }}>{at.toFormat('cccc d LLLL')}</Typography>
            </Box>
          )}
          <MessageBubble
            inbound={message.inbound}
            body={message.body}
            caption={`${message.author} · ${at.toFormat('h:mm a')}`}
          />
        </Box>
      );
    })}
  </Box>
);
